export const siteInfo = {
  name: "97视频",
  tagline: "免费高清在线视频观看平台",
  description: "97视频是国内领先的免费在线视频观看平台，提供电影、电视剧、综艺、动漫、纪录片等海量高清视频资源。支持在线免费看视频，高清不缓冲，为用户打造极致的观影体验。",
  url: "https://www.97shipin.com",
  logo: "97视频",
  founded: "2020年",
  stats: {
    totalUsers: "5000万+",
    dailyActive: "800万+",
    totalVideos: "10万+",
    satisfaction: "98.5%",
  },
  contact: {
    email: "contact@97shipin.com",
    phone: "400-888-9797",
    address: "北京市朝阳区望京科技园A座18层",
    wechat: "97视频官方",
    weibo: "@97视频官方",
  },
  socialLinks: {
    weibo: "https://weibo.com/97shipin",
    wechat: "#",
    douyin: "https://douyin.com/97shipin",
  },
};

export const faqData = [
  {
    question: "97视频需要注册才能观看吗？",
    answer: "不需要！97视频是一个完全免费的在线视频观看平台，所有内容都无需注册即可直接观看。我们致力于为用户提供最便捷的观影体验，打开网站即可畅享高清视频内容。",
  },
  {
    question: "97视频的视频画质如何？",
    answer: "97视频提供超高清的视频画质体验。我们支持1080P全高清和4K超高清画质播放，采用先进的视频压缩和CDN加速技术，确保高清画质下的流畅播放，告别缓冲等待。",
  },
  {
    question: "97视频可以在手机上观看吗？",
    answer: "当然可以！97视频采用响应式设计，完美适配手机、平板、电脑等各类设备。无论您是在通勤路上还是在家休息，都可以随时随地享受高清视频内容。",
  },
  {
    question: "97视频是否支持投屏功能？",
    answer: "支持！97视频兼容主流的投屏协议，您可以将视频内容一键投屏到智能电视或投影仪上，与家人朋友一起享受大屏观影的乐趣。",
  },
  {
    question: "97视频的内容更新频率如何？",
    answer: "97视频的内容团队每天24小时不间断更新，确保您能在第一时间观看到最新的电影、电视剧、综艺节目和动漫作品。热门内容上线后最快1小时内即可在97视频观看。",
  },
  {
    question: "97视频如何保证内容的合法性？",
    answer: "97视频严格遵守国家相关法律法规，所有内容均来源于正规合作渠道。我们与多家正版内容提供商建立了长期合作关系，确保为用户提供合法合规的视频内容服务。",
  },
];

export const brandValues = [
  {
    title: "免费观影",
    description: "坚持为用户提供完全免费的观影服务，打破付费壁垒，让优质视频内容触手可及。",
    icon: "ri-money-cny-circle-line",
  },
  {
    title: "高清画质",
    description: "支持1080P全高清和4K超高清画质，每一帧都清晰细腻，带来影院级观影体验。",
    icon: "ri-4k-line",
  },
  {
    title: "极速播放",
    description: "采用全球CDN加速节点，智能选择最优线路，确保高清视频流畅播放，告别缓冲。",
    icon: "ri-speed-up-line",
  },
  {
    title: "海量资源",
    description: "汇聚电影、电视剧、综艺、动漫、纪录片等10万+优质视频内容，满足各类观影需求。",
    icon: "ri-database-2-line",
  },
];

export const reputationData = [
  { label: "累计用户", value: "5000万+", icon: "ri-user-heart-line" },
  { label: "日均活跃", value: "800万+", icon: "ri-fire-line" },
  { label: "视频资源", value: "10万+", icon: "ri-vidicon-line" },
  { label: "用户好评率", value: "98.5%", icon: "ri-thumb-up-line" },
  { label: "合作平台", value: "200+", icon: "ri-shake-hands-line" },
  { label: "服务年限", value: "6年+", icon: "ri-calendar-check-line" },
];